import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const ListingGroupStaggerIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper {...props} fill="none" viewBox="0 0 19 15">
      <path
        d="M5 10.5V1H18.5V10.5H5Z"
        stroke="inherit"
        strokeWidth={0.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3V12.5H15.5"
        stroke="inherit"
        strokeWidth={0.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 4V14.5H13.5"
        stroke="inherit"
        strokeWidth={0.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8H8V6.75H10V8ZM12 6.75H10V5.5H12V6.75ZM14 5.5H12V4.25H14V5.5ZM16 4.25H14V3H16V4.25Z"
        stroke="inherit"
        strokeWidth={0.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgWrapper>
  );
};
